(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zero-reel-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zl-scroll-wardrobe')) {
  class ZeroLimitScrollWardrobe extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.pin = this.querySelector('.zl-wardrobe__pin');
      this.figure = this.querySelector('.zl-wardrobe__figure');
      this.looks = Array.from(this.querySelectorAll('[data-outfit]')).map(el => ({
        el, settled: el.querySelector('[data-settled]'), flight: el.querySelector('[data-flight]'),
        image: el.querySelector('[data-settled] img'), kind: el.dataset.kind
      }));
      this.buttons = Array.from(this.querySelectorAll('[data-select]'));
      this.details = Array.from(this.querySelectorAll('[data-detail]'));
      this.counter = this.querySelector('[data-current]');
      this.progress = this.querySelector('[data-progress]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.announcement = this.querySelector('[data-announcement]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.active = -1;
      this.current = 0;
      this.target = 0;
      this.raf = 0;
      this.pending = null;
      this.transition = null;
      this.visible = new Set();
      this.looks.forEach(look => { look.el.classList.remove('is-first'); look.el.style.visibility = 'hidden'; });
      this.measure();
      this.target = this.nearestIndex();
      this.commit(this.target);
      this.buttons.forEach((button, i) => button.addEventListener('click', () => this.go(i), options));
      this.previous.addEventListener('click', () => this.go(this.target - 1), options);
      this.next.addEventListener('click', () => this.go(this.target + 1), options);
      this.pin.addEventListener('keydown', event => {
        if (event.target.matches('input,select,textarea')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.target + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      window.addEventListener('scroll', () => this.onScroll(), { ...options, passive: true });
      const resize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => { this.measure(); this.onScroll(); }, 100);
      };
      window.addEventListener('resize', resize, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(resize);
      this.resizeObserver.observe(this.pin);
      this.reduced.addEventListener('change', () => {
        this.stop(); this.commit(this.target);
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { this.stop(); this.commit(this.target); }
        else { this.measure(); this.onScroll(); }
      }, options);
      window.addEventListener('pageshow', () => {
        this.measure(); this.stop(); this.target = this.nearestIndex(); this.commit(this.target);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('[data-outfit]');
        if (block && this.contains(block)) this.go(Number(block.dataset.outfit), true);
      }, options);
      this.warmAdjacent();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resizeObserver?.disconnect(); this.stop();
      clearTimeout(this.resizeTimer); clearTimeout(this.announceTimer);
    }
    stop() {
      cancelAnimationFrame(this.raf); this.raf = 0; this.transition = null; this.pending = null;
    }
    measure() {
      this.start = window.scrollY + this.getBoundingClientRect().top;
      this.pinHeight = this.pin.offsetHeight;
      this.range = Math.max(1, this.offsetHeight - this.pinHeight);
      this.step = this.range / Math.max(1, this.looks.length - 1);
    }
    clampIndex(index) { return Math.max(0, Math.min(this.looks.length - 1, index)); }
    nearestIndex() { return this.clampIndex(Math.round((window.scrollY - this.start) / this.step)); }
    onScroll() {
      const raw = Math.max(0, Math.min(this.looks.length - 1, (window.scrollY - this.start) / this.step));
      if (Math.abs(raw - this.target) > .56) this.target = this.clampIndex(Math.round(raw));
      this.previous.disabled = this.target === 0;
      this.next.disabled = this.target === this.looks.length - 1;
      const outside = window.scrollY < this.start - this.pinHeight || window.scrollY > this.start + this.range + this.pinHeight;
      if (outside || this.reduced.matches || document.hidden) {
        this.stop();
        if (this.current !== this.target || this.dataset.motion !== 'idle') this.commit(this.target);
        return;
      }
      this.requestChange();
    }
    go(index, instant = false) {
      this.target = this.clampIndex(index);
      window.scrollTo({ top: this.start + this.step * this.target, behavior: 'instant' });
      this.previous.disabled = this.target === 0;
      this.next.disabled = this.target === this.looks.length - 1;
      if (instant || this.reduced.matches) { this.stop(); this.commit(this.target); }
      else this.requestChange();
    }
    ready(index) {
      const look = this.looks[index];
      if (!look.decoded) {
        look.decoded = look.image.decode().then(() => true).catch(() => {
          look.decoded = null;
          return look.image.complete && look.image.naturalWidth > 0;
        });
      }
      return look.decoded;
    }
    warmAdjacent() {
      [this.current - 1, this.current + 1].forEach(i => {
        if (i >= 0 && i < this.looks.length) this.ready(i);
      });
    }
    requestChange() {
      if (this.transition || this.target === this.current || this.pending === this.target) return;
      const destination = this.target;
      this.pending = destination;
      this.ready(destination).then(ready => {
        if (!this.isConnected || this.pending !== destination) return;
        this.pending = null;
        if (!ready) { this.target = this.current; return; }
        if (destination !== this.target) { this.requestChange(); return; }
        if (this.reduced.matches || document.hidden) { this.commit(destination); return; }
        this.begin(destination);
      });
    }
    setVisible(indices) {
      const wanted = new Set(indices);
      this.visible.forEach(i => {
        if (!wanted.has(i)) {
          const look = this.looks[i];
          look.el.style.visibility = 'hidden'; look.el.classList.remove('is-moving');
          look.settled.style.opacity = '0'; look.flight.style.opacity = '0';
        }
      });
      wanted.forEach(i => {
        if (!this.visible.has(i)) this.looks[i].el.style.visibility = 'visible';
      });
      this.visible = wanted;
    }
    begin(destination) {
      this.transition = { from: this.current, to: destination, direction: Math.sign(destination - this.current), start: null };
      this.setVisible([this.current, destination]);
      this.looks[this.current].el.classList.add('is-moving');
      this.looks[destination].el.classList.add('is-moving');
      this.looks[this.current].el.style.zIndex = '2';
      this.looks[destination].el.style.zIndex = '3';
      this.figure.classList.toggle('is-tee-change', this.looks[this.current].kind === 'tee' && this.looks[destination].kind === 'tee');
      this.dataset.motion = 'changing';
      this.paint(0);
      this.raf = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      this.raf = 0;
      if (!this.transition) return;
      if (this.transition.start === null) this.transition.start = time;
      const phase = Math.min(1, (time - this.transition.start) / 420);
      this.paint(phase);
      if (phase < 1) this.raf = requestAnimationFrame(next => this.tick(next));
      else {
        const destination = this.transition.to;
        this.transition = null;
        this.commit(destination);
        this.requestChange();
      }
    }
    paint(phase) {
      const { from, to, direction } = this.transition;
      const ease = phase * phase * (3 - 2 * phase);
      const outgoing = this.looks[from], incoming = this.looks[to];
      const flight = Math.sin(Math.PI * phase);
      outgoing.settled.style.opacity = String(1 - ease);
      incoming.settled.style.opacity = String(ease);
      outgoing.flight.style.opacity = String(flight * .72);
      incoming.flight.style.opacity = String(flight * .82);
      outgoing.flight.style.transform = 'translate3d(' + (-42 * ease * direction) + '%,0,0)';
      incoming.flight.style.transform = 'translate3d(' + (42 * (1 - ease) * direction) + '%,0,0)';
      this.dataset.phase = phase.toFixed(3);
      this.progress.style.transform = 'scaleX(' + ((from + (to - from) * ease + 1) / this.looks.length) + ')';
      this.updateUI(phase < .5 ? from : to);
    }
    commit(index) {
      this.current = index;
      this.setVisible([index]);
      const look = this.looks[index];
      look.el.classList.remove('is-moving'); look.el.style.zIndex = '2';
      look.settled.style.opacity = '1'; look.flight.style.opacity = '0';
      this.figure.classList.remove('is-tee-change');
      this.dataset.motion = 'idle'; this.dataset.phase = '0.000';
      this.progress.style.transform = 'scaleX(' + ((index + 1) / this.looks.length) + ')';
      this.updateUI(index);
      this.previous.disabled = this.target === 0;
      this.next.disabled = this.target === this.looks.length - 1;
      this.warmAdjacent();
    }
    updateUI(index) {
      if (this.active === index) return;
      this.active = index; this.dataset.active = String(index);
      this.counter.textContent = String(index + 1).padStart(2, '0');
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      this.details.forEach((detail, i) => { detail.hidden = i !== index; });
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        this.announcement.textContent = String(index + 1) + ' / ' + this.looks.length + ' · ' + this.buttons[index].getAttribute('aria-label');
      }, 200);
    }
  }
  customElements.define('zl-scroll-wardrobe', ZeroLimitScrollWardrobe);
}


  } catch(e) { console.error(e); }
})();
})();
